import { MarketType } from "../../../../../types/types";
import memberNoLengthValidation from "../../../../../utils/formValidation/memberNoLengthValidation";

export default function recipientNoValidator(market: MarketType) {
  return (_: any, value: any) => {
    if (!value) return Promise.resolve();

    const ids = value
      .split(",")
      .map((s: string) => s.trim())
      .filter(Boolean);

    const invalidIds = ids.filter((id: string) => !memberNoLengthValidation(market, id));

    return invalidIds.length > 0
      ? Promise.reject(
        "Please enter the member number in the correct format."
      )
      : Promise.resolve();
  };
}